import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { ListItemText } from '@mui/material';
import { StyledSubItem } from './Sidebar.styles';

const isExternalLink = (url) => {
	return url && (url.startsWith('http://') || url.startsWith('https://'));
};

const SidebarSubItem = ({ item, onMobileItemClick }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const isActive = location.pathname === item.path;
	const isExternal = isExternalLink(item.path);

	const handleClick = (event) => {
		event.preventDefault();
		if (isExternal) {
			window.open(item.path, '_blank', 'noopener,noreferrer');
		} else {
			navigate(item.path);
		}
		onMobileItemClick();
	};

	return (
		<StyledSubItem
			onClick={handleClick}
			isActive={isActive}
			component={isExternal ? 'a' : 'div'}
			href={isExternal ? item.path : undefined}
			target={isExternal ? '_blank' : undefined}
			rel={isExternal ? 'noopener noreferrer' : undefined}
		>
			<ListItemText
				primary={item.title}
				sx={{
					'& .MuiListItemText-primary': {
						fontSize: '0.875rem'
					}
				}}
			/>
		</StyledSubItem>
	);
};

export default SidebarSubItem;
